import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { EnvironmentLoaderService } from 'src/app/shared/services/environment-loader.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'adm-user-not-valid',
  templateUrl: './user-not-valid.component.html',
  styleUrls: ['./user-not-valid.component.scss'],
  imports: [MatButtonModule],
})
export class UserNotValidComponent {
  authService = inject(AuthService);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  public publicPortalName = this.environmentLoaderService.config.publicPortalName;
  public publicPortalBaseUrl = this.environmentLoaderService.config.publicPortalBaseUrl;

  public goToPublicPortal() {
    document.location.href = this.publicPortalBaseUrl;
  }
}
